import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "事件库", to: "/events" },
  { label: "热瓜雷达", to: "/#hot-radar" },
  { label: "关于我们", to: "/about" },
];

export default function SiteNavbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const value = keyword.trim();
    setSearchOpen(false);
    setMenuOpen(false);
    if (!value) {
      navigate("/events");
      return;
    }
    navigate(`/events?q=${encodeURIComponent(value)}`);
    setKeyword("");
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-[68px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 group" aria-label="网报吃瓜首页">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-plant-line text-lg" />
            <span className="absolute -right-0.5 -bottom-0.5 h-3 w-3 rounded-full bg-accent-500 border-2 border-background-50" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">网报吃瓜</span>
            <span className="hidden md:block text-[10px] tracking-[0.3em] text-foreground-500 mt-0.5">
              GUA&nbsp;ARCHIVE
            </span>
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className="px-3.5 py-2 text-sm font-medium text-foreground-700 rounded-md transition-colors hover:bg-background-100 hover:text-primary-700 whitespace-nowrap"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <form onSubmit={submitSearch} className="hidden lg:flex items-center">
            <div
              className={`flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 transition-all ${
                searchOpen ? "w-56" : "w-40"
              }`}
            >
              <i className="ri-search-line text-foreground-500 text-base" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onFocus={() => setSearchOpen(true)}
                onBlur={() => setSearchOpen(false)}
                placeholder="搜事件、话题、关键词"
                aria-label="站内搜索"
                className="w-full bg-transparent py-2 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
              />
            </div>
          </form>

          <Link
            to="/events"
            className="hidden md:inline-flex items-center gap-1.5 rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap"
          >
            <i className="ri-fire-line" />
            追热瓜
          </Link>

          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-6 pt-4">
          <form onSubmit={submitSearch} className="mb-4">
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3">
              <i className="ri-search-line text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜事件、话题、关键词"
                aria-label="站内搜索"
                className="w-full bg-transparent py-2.5 text-sm outline-none"
              />
            </div>
          </form>
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className="block rounded-md px-3 py-3 text-base font-medium text-foreground-800 hover:bg-background-100"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}